import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { Typography } from '@mui/material';
import { UserModel } from 'models';
import React from 'react';
import { useQuery } from 'react-query';
import { connect } from 'react-redux';
import {
  checkDownloads,
  getresetDownloadsLimits,
} from 'services/productService';
import DashboardStyles, { FilmCounterDownload } from 'styles/dashboard';
import combineStyles from 'utils/combineStyles';
import MovieStyles from './PStyles';

interface DownloadsCounterProps {
  user: UserModel;
}

const DownloadsCounter: React.FC<DownloadsCounterProps> = ({ user }) => {
  const { data: downloadCount, isLoading: downloadsLoading } = useQuery(
    ['downloadCount'],
    () => checkDownloads()
  );

  const { data: downloadsInfo, isSuccess: downloadsInfoSuccess } = useQuery(
    ['downloadLimit'],
    () => getresetDownloadsLimits()
  );

  const downloadLimit =
    downloadsInfoSuccess && downloadsInfo ? downloadsInfo.downloadLimit : 10;

  let displayCount = '';

  if (user.role === 'staff') {
    displayCount = downloadCount;
  } else if (user.role === 'user') {
    displayCount = `${downloadCount} / ${downloadLimit}`;
  }

  return (
    <Box sx={FilmCounterDownload.filmCounter}>
      <Box sx={FilmCounterDownload.filmCounter.text}>
        <Typography variant='h3'>{displayCount}</Typography>
        <Typography variant='h4'>Downloaded films</Typography>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user,
});

const mapDispatchToProps = {};

const ConnectedDownloadsCounter = connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadsCounter);

const combinedStyles = combineStyles(DashboardStyles, MovieStyles);
export default withStyles(combinedStyles)(ConnectedDownloadsCounter);
